import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const PcsProgramSchema = withDefaults({
  type: 'pcs-program',
  fields: [
    {
      kind: 'attribute',
      name: 'description',
    },
    {
      kind: 'attribute',
      name: 'metadata',
    },
    {
      kind: 'hasMany',
      name: 'pcsCards',
      type: 'pcs-card',
      options: {
        async: false,
        inverse: 'pcsProgram',
      },
    },
  ],
});

export default PcsProgramSchema;
